import CheckSVG from "../../../../../public/icons/check.svg";
import React from "react";

export const ShCheckoutReturnPolicyInfo = ( { className = ""}) => {
    return <div className={"w-100 d-flex align-items-center justify-content-center"}>
        <CheckSVG className="mr-2 svg-green opacity-75 svg-small"/>
        <p className={"text-center small-text opacity-75 "}>14 Tage Geld-zurück-Garantie</p>
    </div>;
}
